import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import styles from './CollectionCard.module.css'
import Link from '@/components/link'
import { Collection } from '@/utils/types/collections'
import CollectionIcon from '@/components/collection-icon'

const CollectionCard: FC<{ collection: Collection }> = ({ collection }): ReactElement => {
	return (
		<Link className={styles.root} href={`/collection/${collection?.slug}`}>
			<CollectionIcon className={styles.imageWrapper} collection={collection} />
			<div className={styles.body}>
				<div className={styles.gradientBox}>
					{!!collection?.sponsored && (
						<p className={classNames(styles.sponsored, 'text-xxs', 'normal')}>Sponsored</p>
					)}
				</div>
				<p className={classNames(styles.title, 'display-xs', 'semibold')}>{collection?.name}</p>
				<div className={styles.detailsContainer}>
					<div className={styles.supplyContainer}>
						<p className={classNames(styles.supply, 'text-xs')}>
							{collection?.listed === 0 ? 'Supply' : 'Listings'}
						</p>
						<p className={classNames(styles.description, 'text-sm')}>
							{collection?.listed === 0 ? collection?.total_supply : collection?.listed}
						</p>
					</div>
					<div className={styles.inscriptionContainer}>
						<p className={classNames(styles.supply, 'text-xs')}>Inscriptions</p>
						<p
							className={classNames(styles.description, 'text-sm')}
						>{`#${collection?.lowest_inscription_num}-${collection?.highest_inscription_num}`}</p>
					</div>
				</div>
			</div>
		</Link>
	)
}

export default CollectionCard
